/* mm-collection.js — behavior for MadeMine-style collection pages.
 * Uses event delegation so it keeps working after the theme's collection AJAX
 * (filter/sort/paginate) re-renders the grid. No dependencies.
 *
 * Favorite heart: stored in localStorage under MM_FAV_KEY and also emits a
 * `mm:favorite:toggle` CustomEvent (detail: {id, handle, faved}) — the seam a
 * real wishlist app (Swym/Growave/Wishlist King/…) can listen to later.
 */
(function () {
  'use strict';
  if (window.__mmCollectionInit) return;
  window.__mmCollectionInit = true;
  var MM_FAV_KEY = 'mm-favorites';

  function getFavs() {
    try { return JSON.parse(window.localStorage.getItem(MM_FAV_KEY)) || []; }
    catch (e) { return []; }
  }
  function setFavs(list) {
    try { window.localStorage.setItem(MM_FAV_KEY, JSON.stringify(list)); } catch (e) {}
  }
  function isFaved(id) { return getFavs().indexOf(String(id)) !== -1; }

  function paintFavs(root) {
    var scope = root || document;
    var btns = scope.querySelectorAll('[data-mm-fav]');
    for (var i = 0; i < btns.length; i++) {
      var id = btns[i].getAttribute('data-product-id');
      btns[i].classList.toggle('is-faved', isFaved(id));
      btns[i].setAttribute('aria-pressed', isFaved(id) ? 'true' : 'false');
    }
  }

  function toggleFav(btn) {
    var id = String(btn.getAttribute('data-product-id'));
    var handle = btn.getAttribute('data-product-handle') || '';
    var favs = getFavs();
    var idx = favs.indexOf(id);
    var faved;
    if (idx === -1) { favs.push(id); faved = true; }
    else { favs.splice(idx, 1); faved = false; }
    setFavs(favs);
    btn.classList.toggle('is-faved', faved);
    btn.setAttribute('aria-pressed', faved ? 'true' : 'false');
    document.dispatchEvent(new CustomEvent('mm:favorite:toggle', {
      detail: { id: id, handle: handle, faved: faved }
    }));
  }

  // ---- delegated click handling ------------------------------------------
  document.addEventListener('click', function (e) {
    var fav = e.target.closest && e.target.closest('[data-mm-fav]');
    if (fav) { e.preventDefault(); e.stopPropagation(); toggleFav(fav); return; }

    var head = e.target.closest && e.target.closest('.mm-tree__head');
    if (head && head.parentNode) {
      head.parentNode.classList.toggle('is-open');
      head.setAttribute('aria-expanded', head.parentNode.classList.contains('is-open') ? 'true' : 'false');
      return;
    }

    var arrow = e.target.closest && e.target.closest('.mm-carousel__arrow');
    if (arrow) {
      var track = arrow.parentNode.querySelector('.mm-carousel__track');
      if (track) {
        var dir = arrow.classList.contains('mm-carousel__arrow--prev') ? -1 : 1;
        track.scrollBy({ left: dir * Math.max(280, track.clientWidth * 0.8), behavior: 'smooth' });
      }
      return;
    }
  });

  // ---- (re)paint on load + after AJAX section renders --------------------
  function init() { paintFavs(document); }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);

  // Shopify theme editor + Archetype collection AJAX both fire events / mutate DOM.
  document.addEventListener('shopify:section:load', function (e) { paintFavs(e.target); });
  document.addEventListener('collection:reloaded', function () { paintFavs(document); });
  // Fallback: observe the AJAX content container for swaps.
  var ajax = document.getElementById('CollectionAjaxContent');
  if (ajax && 'MutationObserver' in window) {
    new MutationObserver(function () { paintFavs(ajax); }).observe(ajax, { childList: true, subtree: true });
  }
})();
